module.exports = __webpack_public_path__ + "img/events.58549691.svg";